/*
 * @Author: wangshengqiang
 * @Date: 2021-05-12 17:34:35
 * @LastEditTime: 2021-05-12 17:34:50
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import cn from 'classnames';
import './index.less';
export default function CustomIcon(props) {
  const {
    type,
    className,
    active = false,
    onClick
  } = props;
  const cls = cn('cc-custom-icon', className, `cc-custom-icon__${type}`, {
    'cc-custom-icon--active': active
  });
  return /*#__PURE__*/React.createElement("i", {
    className: cls,
    onClick: onClick
  });
}